import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=82703708&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.vue?vue&type=style&index=0&id=82703708&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=82703708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82703708",
  null
  
)

export default component.exports